import React, { useState ,useEffect} from "react";
import { Trash2, Edit, Search } from "lucide-react";

const FeesManagement = () => {
  const [showModal, setShowModal] = useState(false);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingFee, setEditingFee] = useState(null);
  // eslint-disable-next-line
  const [showEntries, setShowEntries] = useState("All");

  const totalPages = 50;
  const [activePage, setActivePage] = useState(1);

  // Generate pagination with ellipsis logic
  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (activePage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (activePage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          activePage - 1,
          activePage,
          activePage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== activePage) {
      setActivePage(page);
    }
  };

  const [feesList, setFeesList] = useState([
    {
      sNo: 1,
      id: "DOC1001",
      name: "Dr. Aarthi Kumar",
      department: "Homeopathy",
      procedure: "IVF Cycle",
      type: "Advanced",
      fee: "80000",
      from: "2025-06-01",
    },
    {
      sNo: 2,
      id: "DOC1002",
      name: "Dr. Ramesh Babul",
      department: "Orthopedics",
      procedure: "Knee Replacement",
      type: "Standard",
      fee: "120000",
      from: "2025-06-05",
    },
  ]);

  const [formData, setFormData] = useState({
    name: "",
    department: "",
    procedure: "",
    type: "",
    fee: "",
    from: "",
  });

  const filteredFees = feesList.filter((fee) =>
    [fee.name, fee.id, fee.department, fee.procedure].some((field) =>
      field.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalFees = filteredFees.length;
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex =
    rowsPerPage === "All" ? totalFees : startIndex + Number(rowsPerPage);
  const currentFees =
    rowsPerPage === "All"
      ? filteredFees
      : filteredFees.slice(startIndex, endIndex);

  const generateFeeId = () => {
    const lastId = parseInt(feesList[feesList.length - 1].id.substring(3), 10);
    return `DOC${String(lastId + 1).padStart(4, "0")}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingFee) {
      setFeesList((prev) =>
        prev.map((f) => (f.id === editingFee.id ? { ...f, ...formData } : f))
      );
    } else {
      const newFee = {
        ...formData,
        id: generateFeeId(),
      };
      setFeesList((prev) => [...prev, newFee]);
    }
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingFee(null);
    setFormData({
      name: "",
      department: "",
      procedure: "",
      type: "",
      fee: "",
      from: "",
    });
  };
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

  return (
    <div className="container-fluid py-3 px-2">
      <style>{`
        .btn-custom { 
          background-color: #01AEBE; 
          color: white; 
          border: none;
        }
        .btn-custom:hover { 
          background-color: #018A97; 
          color: white;
        }
        .btn-custom-outline { 
          background: transparent; 
          color: #01AEBE; 
          border: 1px solid #01AEBE; 
        }
        .btn-custom-outline:hover, .btn-custom-outline.active { 
          background-color: #01AEBE; 
          color: white; 
        }
        .modal-backdrop {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>

      <div className="d-flex justify-content-end align-items-center mb-3">
        <button className="btn btn-custom" onClick={() => setShowModal(true)}>
          <i className="fas fa-plus me-2"></i> Add Fees List
        </button>
      </div>

      {/* <div className="card p-3 mb-3"> */}
      <div className="card card-body mt-2">
        <div className="row mb-2 crm-table-toolbar">
          <div className="col-md-2">
            <div className="input-group">
              <span className="input-group-text">
                <i className="fas fa-table"></i>
              </span>
              <select
                className="form-select"
                onChange={(e) => {
                  setCurrentPage(1);
                  setShowEntries(e.target.value);
                }}
              >
                <option value="All">Show All</option>
                {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
                  <option key={n} value={n}>
                    Show {n}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-7"></div>
          <div className="col-md-3">
            <div className="d-flex align-items-center">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control pe-5"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search
                  size={16}
                  className="position-absolute text-muted"
                  style={{
                    right: "10px",
                    top: "40%",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Fees Table */}
        <div className="table-responsive mt-3">
          <table className="table responsive-table">
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Doctor ID</th>
                <th>Doctor Name</th>
                <th>Department</th>
                <th>Procedure</th>
                <th>Type</th>
                <th>Fee (₹)</th>
                <th>From Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentFees.length > 0 ? (
                currentFees.map((fee, idx) => (
                  <tr key={fee.id} className="align-middle">
                    <td>{startIndex + idx + 1}</td>
                    <td>{fee.id}</td>
                    <td>{fee.name}</td>
                    <td>{fee.department}</td>
                    <td>{fee.procedure}</td>
                    <td>{fee.type}</td>
                    <td>{fee.fee}</td>
                    <td>{fee.from}</td>
                    <td>
                      <button
                        className="btn btn-sm p-1 border-0"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <Trash2 size={16} className="text-danger" />
                      </button>
                      <button
                        className="btn btn-sm p-1 border-0"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <Edit size={16} className="text-primary" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <div className="text-muted">
                      <i className="fas fa-search fa-2x mb-2"></i>
                      <br />
                      No fee entries found matching your search criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && rowsPerPage !== "All" && (
          <div className="container">
            <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={() => activePage > 1 && setActivePage(activePage - 1)}
                disabled={activePage === 1}
              >
                <i className="fas fa-chevron-left"></i>
                <span className="d-none d-sm-inline">Previous</span>
              </button>
              <div
                className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                style={{ maxWidth: "100%" }}
              >
                {pages.map((page, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm px-3 flex-shrink-0 ${
                      page === activePage
                        ? "text-white"
                        : "btn-outline-secondary"
                    }`}
                    style={
                      page === activePage
                        ? { backgroundColor: "#20c997", border: "none" }
                        : {}
                    }
                    onClick={() => handlePageClick(page)}
                    disabled={page === "..."}
                  >
                    {page}
                  </button>
                ))}
              </div>
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={() =>
                  activePage < totalPages && setActivePage(activePage + 1)
                }
                disabled={activePage === totalPages}
              >
                <span className="d-none d-sm-inline">Next</span>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal for Add/Edit Fee */}
      {showModal && (
        <div className="modal d-block modal-backdrop" tabIndex="-1">
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title">
                  {editingFee ? "Edit Fee" : "Add Fees List"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Doctor ID *</label>
                      <input
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Doctor Name *</label>
                      <input
                        name="department"
                        className="form-control"
                        value={formData.department}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Department *</label>
                      <input
                        name="procedure"
                        className="form-control"
                        value={formData.procedure}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Specialty *</label>
                      <input
                        name="type"
                        className="form-control"
                        value={formData.type}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Procedure *</label>
                      <input
                        name="fee"
                        type="number"
                        className="form-control"
                        value={formData.type}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Treatment Type *</label>
                      <input
                        name="from"
                        type="date"
                        className="form-control"
                        value={formData.from}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-14">
                      <label className="form-label">Fee Amount (₹) *</label>
                      <input
                        name="fee"
                        type="number"
                        className="form-control"
                        value={formData.fee}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Registered Date *</label>
                      <input
                        name="fee"
                        type="date"
                        className="form-control"
                        value={formData.fee}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Status *</label>
                      <input
                        name="fee"
                        type="number"
                        className="form-control"
                        value={formData.fee}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-center border-top">
                  {/* <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button> */}
                  <button type="submit" className="btn btn-custom px-4">
                    {editingFee ? "Update Fee" : "Confirm"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeesManagement;
